import {all, takeEvery, put, call } from 'redux-saga/effects';

import actions from "./actions"
import {
    getTariffs,
    getTariffsLog,
    getTariffsLogByDateAndWorkspace,
    getTariffsLogDetails
} from "../../services/tariffs.service";
import { AxiosResponse } from 'axios';
import logError from "../../utils/logError";


export function* GET_ALL_TARIFFS(){
    try{
        const response: AxiosResponse<any> = yield call(getTariffs);
        if(response.data){
            yield put({
                type: actions.SET_ALL_TARIFFS,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/tariffs/sagas/GET_ALL_TARIFFS", e); }
}

export function* GET_TARIFFS_LOG(){
    try{
        const response: AxiosResponse<any> = yield call(getTariffsLog);
        if(response.data){
            yield put({
                type: actions.SET_TARIFFS_LOGS,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/tariffs/sagas/GET_TARIFFS_LOG", e); }
}

export function* GET_TARIFFS_LOG_BY_DATA_AND_WORKSPACE(action:{payload: any, type:string}){
    try{
        const response: AxiosResponse<any> = yield call(
          getTariffsLogByDateAndWorkspace,
          action.payload
        );
        if(response.data){
            yield put({
                type: actions.SET_TARIFFS_LOGS_BY_DATE_AND_WORKSPACE,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/tariffs/sagas/GET_TARIFFS_LOG_BY_DATA_AND_WORKSPACE", e); }
}

export function* GET_TARIFF_LOG_DETAILS(action:{payload: any, type:string}){
    try{
        const { uuid } = action.payload;
        const response: AxiosResponse<any> = yield call(
          getTariffsLogDetails,
          uuid
        );
        if(response.data){
            yield put({
                type: actions.SET_TARIFF_LOG_DETAILS,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/tariffs/sagas/GET_TARIFF_LOG_DETAILS", e); }
}
export default function* RootSaga(){
    yield all([
        takeEvery(actions.GET_ALL_TARIFFS, GET_ALL_TARIFFS),
        takeEvery(actions.GET_TARIFFS_LOGS, GET_TARIFFS_LOG),
        takeEvery(actions.GET_TARIFF_LOG_DETAILS, GET_TARIFF_LOG_DETAILS),
        takeEvery(actions.GET_TARIFFS_LOGS_BY_DATE_AND_WORKSPACE, GET_TARIFFS_LOG_BY_DATA_AND_WORKSPACE)
    ])
}